import { Box, Menu, IconButton, Portal, Flex } from '@react/chakra';
import { CloseIcon, MenuIcon, useDialog } from '@react/chakra/core';

import type { JSX } from 'react';

import { buildHeadingId } from './utils';

import type { IContentTreeProps } from './interface';

interface IPopupProps {
  data: IContentTreeProps[];
}

export function Popup({ data }: IPopupProps): JSX.Element {
  const { isOpen, onOpenChange } = useDialog();

  return (
    <Box top={0} right={0} bottom={0} pos='absolute'>
      <Flex
        top='10%'
        pos='sticky'
        bgColor='white'
        borderRadius='30px'
        alignItems='center'
        justifyContent='center'
      >
        <Menu.Root onOpenChange={onOpenChange}>
          <Menu.Trigger asChild>
            <IconButton variant='ghost' borderRadius='30px'>
              {isOpen ? <CloseIcon stroke='black' /> : <MenuIcon />}
            </IconButton>
          </Menu.Trigger>
          <Portal>
            <Menu.Positioner>
              <Menu.Content w='calc(100dvw - 12px)'>
                {data.map((datumn) => {
                  const { text, level } = datumn;
                  const id = buildHeadingId(datumn);

                  return (
                    <Menu.Item
                      key={id}
                      value={id}
                      px={(level - 1) * 4}
                      onClick={() => {
                        document
                          .querySelector(`.markdown-content [id="${id}"]`)
                          ?.scrollIntoView({
                            block: 'center',
                            behavior: 'smooth',
                          });
                      }}
                    >
                      {text}
                    </Menu.Item>
                  );
                })}
              </Menu.Content>
            </Menu.Positioner>
          </Portal>
        </Menu.Root>
      </Flex>
    </Box>
  );
}
